import {
	Accordion,
	EffectsIcon,
	ToggleGroup,
} from "@au-schein-de/au-ui-library";
import { useTranslation } from "react-i18next";
import { FilterHeader } from "../../filter-header.component";
import { useFiltersContext } from "../../filters.context";

export function EffectsFilter() {
	const { t } = useTranslation("product");
	const { filters, config, onFilterChange } = useFiltersContext();
	const value = filters.effects ?? [];

	return (
		<Accordion.Item
			value="effects"
			variant="filter"
			data-testid="effects-filter"
		>
			<Accordion.Trigger variant="filter" data-testid="effects-filter-trigger">
				<FilterHeader
					title={t("filters.effects")}
					value={Number(value?.length)}
					icon={<EffectsIcon name="analgesic" size="md" />}
				/>
			</Accordion.Trigger>
			<Accordion.Content className="px-4 pb-4">
				<ToggleGroup.Root
					type="multiple"
					variant="secondary"
					size="xs"
					className="flex-wrap justify-start gap-2 pt-3"
					value={value}
					onValueChange={(val) => onFilterChange("effects", val)}
				>
					{config.effects.map((effect) => (
						<ToggleGroup.Item key={effect} value={effect}>
							{/* @ts-ignore: dynamic key generation */}
							{t(`filters.effects.${effect}`)}
						</ToggleGroup.Item>
					))}
				</ToggleGroup.Root>
			</Accordion.Content>
		</Accordion.Item>
	);
}
